import { render } from "./app-text-tooltip.vue?vue&type=template&id=972ae3dc&scoped=true"
import script from "./app-text-tooltip.vue?vue&type=script&lang=js"
export * from "./app-text-tooltip.vue?vue&type=script&lang=js"

import "./app-text-tooltip.vue?vue&type=style&index=0&id=972ae3dc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972ae3dc"],['__file',"src/views/components/text/app-text-tooltip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "972ae3dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('972ae3dc', __exports__)) {
    console.log('reload')
    api.reload('972ae3dc', __exports__)
  }
  
  module.hot.accept("./app-text-tooltip.vue?vue&type=template&id=972ae3dc&scoped=true", () => {
    console.log('re-render')
    api.rerender('972ae3dc', render)
  })

}


export default __exports__